/**
 * Note entity class
 */

import moment from 'moment'

/**
 * NoteFactory
 * returns Note entity class
 *
 * @class NoteFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Note} class
 *
 * @ngdoc factory
 * @name mwApp.factory:NoteFactory
 */
/* @ngInject */
export default function NoteFactory ($sce, Type, Entity) {
  /* === Note class === */

  /**
   * Note model
   *
   * @class Note
   * @classdesc Note model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.Note} Note entity
   */
  function Note () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Note.prototype = Object.create(Entity.prototype)
  Note.prototype.constructor = Note

  /* === Note instance methods & fields === */

  Object.assign(Note.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Note#
     * @type {Object}
     */
    _fields: {
      id: Number,
      createTime: moment,
      comment: String,
      description: Type(String('')),
      issueObject: String,
      subject: String,
      subscriber: 'Subscriber',
      type: String,
      user: 'User'
    },

    /**
     * url template
     *
     * @memberof models.Note#
     * @type {String}
     */
    _urlTemplate: 'api/v2/subscribers/{{subscriber.id}}/notes/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.Note#
     * @type {String}
     */
    _publicUrlTemplate: 'subscribers/{{subscriber.id}}/notes/{{::id}}',

    /**
     * Prepare note
     *
     * @memberof models.Note#
     * @override
     */
    _prepare: function () {
      this._trust()
    },

    /**
     * Create new field with trusted HTML description
     *
     * @memberof models.Note#
     * @return {models.Note} this
     */
    _trust: function () {
      this.descriptionHtml = this.description ? $sce.trustAsHtml(this.description) : $sce.trustAsHtml('')
      return this
    }
  })

  /* === Note static methods & fields === */

  Note.insertImgIntoDiv = function (text) {
    const imgTagRegExp = /(<img)[^>]*(>)/g

    return text.replace(imgTagRegExp, '<div class="note-img">' + '$&' + '</div>')
  }

  // copy all static methods from Entity class
  Object.assign(Note, Entity)
  Note._name = 'Note'
  Note.init()

  // permissions
  Note.access = {
    view: 'viewSubscriberNote',
    create: 'createSubscriberNote',
    edit: 'editSubscriberNote'
  }

  return Note
}
